export default __webpack_public_path__ + "static/media/Ellipse 13.d8807874.png";